import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import type {Template} from "../../types/templates";

export type TemplateState = {
  templates: Template[];
};

const initialState: TemplateState = {
  templates: [],
};

const templateSlice = createSlice({
  name: "templates",
  initialState,
  reducers: {
    addTemplate(state, action: PayloadAction<Template>) {
      state.templates.push(action.payload);
    },

    deleteTemplate(state, action: PayloadAction<string>) {
      state.templates = state.templates.filter(t => {
        const deleteId = action.payload;
        return t.id !== deleteId;
      });
    },

    setTemplates(state, action: PayloadAction<Template[]>) {
      state.templates = action.payload;
    },

  },
});

export const {addTemplate, deleteTemplate, setTemplates} = templateSlice.actions;
export default templateSlice.reducer;

export const selectTemplates = (s: { templates: TemplateState }) => {
  return s.templates.templates ;
}
